import { createAction } from "redux-actions";

export const CONTACT_LIST = "CONTACT_LIST";
export const contactList = createAction(CONTACT_LIST);

export const DETAIL_CONTACT = "DETAIL_CONTACT";
export const detailContact = createAction(DETAIL_CONTACT);

export const REPLY_CONTACT = "REPLY_CONTACT";
export const replyContact = createAction(REPLY_CONTACT);

export const DELETE_CONTACT = "DELETE_CONTACT";
export const deleteContact = createAction(DELETE_CONTACT);
